import { render, staticRenderFns } from "./peopleInformation.vue?vue&type=template&id=e13a3646&scoped=true&"
import script from "./peopleInformation.vue?vue&type=script&lang=ts&"
export * from "./peopleInformation.vue?vue&type=script&lang=ts&"
import style0 from "./peopleInformation.vue?vue&type=style&index=0&id=e13a3646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13a3646",
  null
  
)

export default component.exports